<mat-card class="attendance-card">
  <!-- Header Section -->
  <mat-card-header>
    <mat-card-title>
      <mat-icon class="attendance-icon">{{
        'attendance.icon.browse-gallery' | translate
      }}</mat-icon>
      {{ 'attendance.clock.title' | translate }}
    </mat-card-title>
    <mat-card-subtitle>
      {{ 'attendance.clock.sub-title' | translate }}
    </mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>

  <!-- Dynamic Section -->
  <mat-card-content>
    <div *ngIf="!isDataLoading && !initialDataLoading; else loadingContent">
      <!-- @@@@@@@@@@@@@@@@@@@ Before Clock In @@@@@@@@@@@@@@@@@@@ -->
      <div
        *ngIf="
          !isClockedIn &&
          !isClockedOut &&
          !hasActiveClockInFound &&
          !isDataLoading
        "
      >
        <div class="date-time">
          <!-- Date Section (left) -->
          <div class="date">
            <p class="day">
              {{ getDay() }}, <span [innerHTML]="getDate()"></span>
            </p>
            <p class="month-year">{{ getMonthYear() }}</p>
          </div>
          <!-- Time Section (right) -->
          <div class="time">{{ time }}</div>
        </div>

        <div class="action-buttons">
          <!-- Location Toggle -->
          <div class="location-toggle">
            <button
              mat-button
              (click)="selectLocation('home')"
              [ngClass]="{ selected: location === 'home' }"
            >
              <mat-icon>{{ 'attendance.icon.home' | translate }}</mat-icon>
            </button>
            <button
              mat-button
              (click)="selectLocation('office')"
              [ngClass]="{ selected: location === 'office' }"
            >
              <mat-icon>{{ 'attendance.icon.apartment' | translate }}</mat-icon>
            </button>
          </div>

          <!-- Clock In Button -->
          <div class="clock-toggle">
            <button
              class="clock-in-button"
              mat-raised-button
              color="primary"
              (click)="clockIn()"
              [disabled]="disableClockInButton"
            >
              {{ 'attendance.clock.clock-in' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div
        *ngIf="
          !isClockedIn &&
          !isClockedOut &&
          !hasActiveClockInFound &&
          isDataLoading
        "
      >
        <app-attendance-card-skeleton></app-attendance-card-skeleton>
      </div>

      <!-- @@@@@@@@@@@@@@@@@@@ Clocked In Section @@@@@@@@@@@@@@@@@@@ -->
      <div *ngIf="hasActiveClockInFound && !isClockedOut && !isDataLoading">
        <div class="counting-time">
          <!-- Clocked in from/at (left) -->
          <div class="clocked-in">
            <p class="place">
              {{ 'attendance.clock.clocked-in' | translate }}
              <span
                ><mat-icon>{{
                  location === 'home' ? 'home' : 'apartment'
                }}</mat-icon></span
              >
            </p>
            <p class="clock-started-time">
              <span *ngIf="hasActiveClockInFound; else defaultTime">{{
                formattedClockInTime
              }}</span>
              <ng-template #defaultTime>{{ getClockedInTime() }}</ng-template>
            </p>
          </div>
          <!-- Counting Time (right) -->
          <div class="time">{{ elapsedTime }}</div>
        </div>

        <div class="clock-toggle">
          <button
            class="clock-out-button"
            mat-raised-button
            (click)="clockOut()"
          >
            {{ 'attendance.clock.clock-out' | translate }}
          </button>
        </div>
      </div>

      <!-- @@@@@@@@@@@@@@@@@@@ After Clock Out Section @@@@@@@@@@@@@@@@@@@ -->
      <div *ngIf="isClockedOut">
        <div class="completed-time">
          <!-- Time Difference -->
          <div class="time-difference">
            <!-- Clocked in Section -->
            <div class="time-clocked-in">
              <p class="place">
                {{ 'attendance.clock.clocked-in' | translate }}
                <span
                  ><mat-icon>{{
                    location === 'home' ? 'home' : 'apartment'
                  }}</mat-icon></span
                >
              </p>

              <p class="clock-stopped-time">
                <span *ngIf="hasActiveClockInFound; else defaultTime">{{
                  formattedClockInTime
                }}</span>
                <ng-template #defaultTime>{{ getClockedInTime() }}</ng-template>
              </p>
            </div>

            <!-- Clocked out Section -->
            <div class="time-clocked-out">
              <p class="place">
                {{ 'attendance.clock.clocked-out' | translate }}
                <span
                  ><mat-icon>{{
                    location === 'home' ? 'home' : 'apartment'
                  }}</mat-icon></span
                >
              </p>
              <p class="clock-stopped-time">{{ getClockedOutTime() }}</p>
            </div>
          </div>

          <!-- Complete Time (right) -->
          <div
            class="worked-hour-count"
            [ngClass]="{
              'time-valid': timeDifferenceIsValid,
              'time-invalid': !timeDifferenceIsValid
            }"
          >
            {{ timeDifference }}
          </div>
        </div>
      </div>
    </div>
    <!-- Loading Template -->
  </mat-card-content>
  <ng-template #loadingContent>
    <app-attendance-card-skeleton></app-attendance-card-skeleton>
  </ng-template>
</mat-card>
